mainApp.service('DevicesService', function () {
	return {
		getDeviceCategories: function () {
			return {
				DEVICE_CATEGORY_UNKNOWN: null,
				DEVICE_CATEGORY_MOBILE_PHONE: 'Mobile Phone',
				DEVICE_CATEGORY_TABLET: 'Tablet',
				DEVICE_CATEGORY_SOCKET: 'Socket',
				DEVICE_CATEGORY_DESKTOP: 'Desktop',
				DEVICE_CATEGORY_VM: 'VM',
			};
		},
		getProtocols: function () {
			return {
				L2TP_TUNNEL: 'L2TP TUNNEL',
				L2TP_SESSION: 'L2TP SESSION',
				DTLS: 'DTLS',
				OpenVPN: 'OpenVPN',
				IPIP: 'IPIP',
				NO_TUNNEL: 'NO TUNNEL',
			};
		},
		getOs: function () {
			return {
				OS_ANDROID: 'Android',
				OS_LINUX: 'Linux',
				OS_WINDOWS: 'Windows',
				OS_IOS: 'iOS',
				OS_MAC: 'macOS',
				OS_UNKNOWN: null,
			};
		},
		getInternetConnectivityType: function () {
			return {
				CONN_UNKNOWN: null,
				CONN_WIFI: 'WiFi',
				CONN_3G: '3G',
				CONN_WIRED: 'Wired',
			};
		},
		getDevicesIcons: function () {
			return {
				site: '/public/images/entities/branch.png',
				"login": '/public/images/entities/user.png',
				"datapoint": '/public/images/bullet-green.png',
				"siteHEADQUARTERS": '/public/images/entities/HQ.png',
				"siteBRANCH": '/public/images/entities/branch.png',
				"siteCLOUD_DC": '/public/images/entities/sitecloud.png',
				"siteDATACENTER": '/public/images/entities/datacenter.png',
				"OS_ANDROID": '/public/images/entities/phone-android.png',
				"OS_IOS": '/public/images/entities/phone-iphone.png',
				"loginandroid": '/public/images/entities/phone-android.png',
				"loginwindows": '/public/images/entities/laptop-windows.png',
				"loginmac": '/public/images/entities/laptop-apple.png',
				"loginOS_ANDROID": '/public/images/entities/phone-android.png',
				"loginOS_IOS": '/public/images/entities/phone-iphone.png',
				"loginOS_WINDOWS": '/public/images/entities/laptop-windows.png',
				"loginOS_MAC": '/public/images/entities/laptop-apple.png',
				"loginDEVICE_CATEGORY_MOBILE_PHONEOS_ANDROID": '/public/images/entities/phone-android.png',
				"loginDEVICE_CATEGORY_MOBILE_PHONEOS_IOS": '/public/images/entities/phone-iphone.png',
				"loginDEVICE_CATEGORY_TABLETOS_ANDROID": '/public/images/entities/phone-android.png',
				"loginDEVICE_CATEGORY_TABLETOS_IOS": '/public/images/entities/phone-iphone.png',
				"loginDEVICE_CATEGORY_DESKTOPOS_WINDOWS": '/public/images/entities/laptop-windows.png',
				"loginDEVICE_CATEGORY_VMOS_WINDOWS":'/public/images/entities/laptop-windows.png',
				"loginDEVICE_CATEGORY_DESKTOPOS_MAC": '/public/images/entities/laptop-apple.png'
			}
		},
	};
});

